export default __webpack_public_path__ + "static/worker-using-table-tool-259474cb0063fda4b2c03e02c1dafec4.jpg";